import React from 'react'

// mui
import { Typography } from '@mui/material'

export default function FormSectionHeader({ text }) {
    return (<Typography variant='h6' sx={{ marginTop: 4, marginBottom: 2}}>{text}</Typography>)
}